export const locale = {
  lang: 'en',
  data: {
    MASSIVE_COMPANY_DIALOG: {
      MASSIVE_COMPANY_IMPORT: 'Massive import companies',
      CREATION: 'Create',
      VERIFICATION: 'Check',
      INSERTION: 'Edit',
      VALIDATION: 'Validate',
      IMPORT_OUTCOME: 'Import outcome',

      COMPANY_TYPE: 'Company type',
      COMPANY_IMPORT_TYPE_SELLER_DEBTOR: 'Submit invoice trading opportunity',
      COMPANY_IMPORT_TYPE_DEBTOR_SELLER: 'Submit reverse opportunity',
      COMPANY_IMPORT_TYPE_SELLER: 'Seller',
      COMPANY_IMPORT_TYPE_DEBTOR: 'Debtor',
      DESCRIPTION_SELLER_DEBTOR_1: 'Enter in the <strong>first line</strong> the seller\'s informations',
      DESCRIPTION_SELLER_DEBTOR_2: 'In the rows below you can enter a list of customers',
      DESCRIPTION_DEBTOR_SELLER_1: 'Enter in the <strong>first line</strong> the debtor\'s informations',
      DESCRIPTION_DEBTOR_SELLER_2: 'In the rows below you can enter a list of suppliers',
      DESCRIPTION_DEBTOR: 'Enter a list of debtors only.',
      DESCRIPTION_SELLER: 'Enter a list of sellers only.',
      ALTERNATIVE: 'Alternatively, you can upload an excel file in standard format:',
      DOWNLOAD_TEMPALTE: 'Download tempalte',
      BROWSE: 'Browse',
      IMPORT_FILE: 'Import file',
      ATTENTION: '*Warning: you are importing a',

      WAITING_IMPORT: 'Import in progress...',
      WAITING_UPDATE: 'Update in progress...',

      BUSINESS_NAME: 'Business name',
      TAX_CODE: 'Tax code',
      TRANSFER_TYPE: 'Transfer type',
      INVOICE_VALUE: 'Issued invoice value',
      REQUIRED_OPERATING_LIMIT: 'Required operating limit',

      ProSolutoConfirmNotification: 'PRO-SOLUTO with confirm and notification',
      ProSolutoNoConfirmNotification: 'PRO-SOLUTO without confirm with notification',
      ProSolutoNoConfirmNoNotification: 'PRO-SOLUTO without confirm and notification',
      ProSolvendoConfirmNotification: 'PRO-SOLVENDO with confirm and notification',
      ProSolvendoNoConfirmNotification: 'PRO-SOLVENDO without confirm with notification',
      ProSolvendoNoConfirmNoNotification: 'PRO-SOLVENDO without confirm and notification',
      ProSolvendoConfirmNoNotification: 'PRO-SOLVENDO with confirm without notification',
      IasProSolutoConfirmNotification: 'IAS-Compliant - PRO-SOLUTO with confirm with notification',
      IasProSolutoConfirmNoNotification: 'IAS-Compliant - PRO-SOLUTO with confirm without notification',
      IasProSolutoNoConfirmNotification: 'IAS-Compliant - PRO-SOLUTO without confirm with notification',
      IasProSolutoNoConfirmNoNotification: 'IAS-Compliant - PRO-SOLUTO without confirm without notification',

      CRIBIS: 'CRIBIS',
      COMPANY: 'Company',
      ROLE: 'Role',
      LINK: 'Link',
      INFO_TOOLTIP: {
        CRIBIS: 'Indicates whether the tax code entered was found on the CRIBIS database (valid only for Italian companies)',
        COMPANY: 'Indicates whether the company is already registered',
        ROLE: 'Indicates whether a company already registered is also present in the requested role (seller or debtor)',
        LINK: 'Indicates whether there is already a seller-debtor link between the companies',
      },
      CUSTOMERS: 'Customers',
      SUPPLIERS: 'Suppliers',

      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'Email',
      PHONE: 'Phone',

      IMPORT_COMPLETE: 'Import successfully completed',

      ACTION: {
        CANCEL: 'Cancel',
        SEND: 'Send',
        CONFIRM: 'Confirm',
        BACK: 'Back',
      },

      ERROR: {
        ZERO: 'Warning: some values are set to 0',
        ERROR: 'Error',
      },

      FILE_WARNING: {
        SELLER: 'list of sellers only',
        DEBTOR: 'list of debtors only',
        SELLER_DEBTOR: 'seller and a list of his customers.',
        DEBTOR_SELLER: 'debtor and a list of his suppliers.',
      },
    },
  },
};
